import React, { useEffect, useState } from "react";
import { Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postRequestcall } from "../../comman/util/postRequest";
import { RESET_PASSWORD } from "../../constants/apiurl";
import "./ResentpasswordPage.css";
import { EYE, EYE_OFF } from "../../comman/components/CommonimagePath";
import FormgroupPage, { FormLabel } from "../../comman/formgroup/FormgroupPage";
import InputgroupPage from "../../comman/inputgroup/InputgroupPage";
import ButtonPage from "../../comman/button/ButtonPage";

function ResentpasswordPage() {
  const emailRegex = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  const { t } = useTranslation();
  const passRegex =
    /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\w\W]){1,})(?!.*\s).{8,}$/;
  const [errorMsg, setErrormsg] = useState({
    email: "",
    password: "",
    cpassword: "",
  });
  const [secure, setSecure] = useState({
    password: true,
    cpassword: true,
  });
  const [inputevalue, setInputvalue] = useState({
    email: "",
    password: "",
    cpassword: "",
  });
  const navigate = useNavigate();
  var parseQueryString = () => {
    var str = window.location.search;
    var objURL = {};
    str.replace(
      new RegExp("([^?=&]+)(=([^&]*))?", "g"),
      function ($0, $1, $2, $3) {
        objURL[$1] = $3;
      }
    );
    return objURL;
  };
  const location = useLocation();
  let session_token = location.pathname.split("/").pop();
  const { email } = parseQueryString();
  useEffect(() => {
    if (email === undefined) {
      navigate("/")(session_token);
    } else {
      loadDataEmail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadDataEmail = () => {
    setInputvalue({
      ...inputevalue,
      email: email,
    });
  };
  const validation = () => {
    let checkValue = "";

    if (!emailRegex.test(inputevalue.email)) {
      errorMsg.email = "pages.login.email-warn";
      checkValue = "false";
    }
    if (!passRegex.test(inputevalue.password)) {
      errorMsg.password = "pages.login.password_valid";
      checkValue = "false";
    }
    if (!passRegex.test(inputevalue.password)) {
      errorMsg.cpassword = "pages.login.password_valid";
      checkValue = "false";
    }
    if (inputevalue.cpassword !== inputevalue.password) {
      errorMsg.cpassword = "pages.profile.confirm_password_valid";
      checkValue = "false";
    }
    if (inputevalue.password === "") {
      errorMsg.password = "pages.login.password_warn";
      checkValue = "false";
    }
    if (inputevalue.cpassword === "") {
      errorMsg.cpassword = "pages.profile.confirm_password_place";
      checkValue = "false";
    }
    setErrormsg({
      email: errorMsg.email,
      password: errorMsg.password,
      cpassword: errorMsg.cpassword,
    });

    if (checkValue === "false") {
      return false;
    } else {
      return true;
    }
  };
  const inputValuechange = (e) => {
    setInputvalue({
      ...inputevalue,
      [e.target.name]: e.target.value,
    });
    setErrormsg({
      ...errorMsg,
      [e.target.name]: "",
    });
  };
  const CallResetPassword = async (e) => {
    e.preventDefault();
    if (validation()) {
      const payload = {
        email: inputevalue.email,
        token: session_token,
        password: inputevalue.cpassword,
      };
      let response = await postRequestcall(RESET_PASSWORD, "", payload);
      let result = await response.json();
      if (response?.status === 200) {
        toast(t("pages.Password reset successfull please login"));
        navigate("/login");
      } else {
        // ("response", result)
        if (result?.msg === 404) {
          toast.error(t("pages.Token Expire"));
        } else if (result?.msg === 500) {
          toast.error(t("pages.internal"));
        }
      }
    }
  };

  return (
    <aside className="reset_password">
      <Container>
        <div className="justify-content-center row">
          <div className="col-12 col-xl-9">
            <div className="card">
              <div className="card-body">
                <Row>
                  <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <Form onSubmit={CallResetPassword} className="forgot-form">
                      <h3 className="mb-4">{t("pages.Reset Password")}</h3>
                      <div className="form-content">
                       <FormgroupPage className="mb-2" require={false} label={t("pages.profile.email_address")} placeholder={t("pages.checkout.email_address_warn")}  value={inputevalue.email}  name={"email"}  
                         onChange={(e) => inputValuechange(e)} error={t(errorMsg?.email)} />
                        <Form.Group className="mb-3">
                        <FormLabel require={false} label={t("pages.profile.new_password")} />
                        <InputgroupPage 
                        className="right_border-0"
                        onChange={(e) => inputValuechange(e)}
                         value={inputevalue.password}
                         type={secure.password ? "password" : "text"}
                          placeholder={t("pages.login.password")}
                           name={"password"}
                          error= {t(errorMsg.password)}
                         onClick={() =>
                         setSecure({
                          ...secure,
                          password: !secure.password,
                         })
                         }
                         src={secure.password ? EYE : EYE_OFF}
                        />
                        </Form.Group>
                        <Form.Group className="mb-3">
                        <FormLabel require={false} label={t("pages.profile.confirm_password")} />
                        <InputgroupPage 
                         className="right_border-0"
                         onChange={(e) => inputValuechange(e)}
                         value={inputevalue.cpassword}
                         type={secure.cpassword ? "password" : "text"}
                         placeholder={t("pages.profile.confirm_password_place")}
                         name={"cpassword"}
                         error= {t(errorMsg.cpassword)}
                         onClick={() =>
                          setSecure({
                            ...secure,
                            cpassword: !secure.cpassword,
                          })
                        }
                         src={secure.cpassword ? EYE : EYE_OFF}
                        />
                        </Form.Group>
                        <div>
                         <ButtonPage
                              Text={t("pages.Reset Password")}
                              className={`button-submit float-left`}
                          /> 
                        </div>
                      </div>
                    </Form>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </aside>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  storeDetail: state?.dashboard?.storeDetail,
});

export default connect(mapStateToProps)(ResentpasswordPage);
